import { faPlus as falPlus } from '@fortawesome/pro-light-svg-icons';
import Button from '@prio365/prio365-react-library/lib/Button';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { makePrioStyles } from '../../../../../../theme/utils';

const useStyles = makePrioStyles((theme) => ({
  root: {
    width: '100%',
    border: `2px dashed ${theme.colors.application.border}`,
    borderRadius: theme.borderRadius.regular,
  },
}));

interface CreateAllocationButtonProps {
  className?: string;
  onClick: () => void;
}

const CreateAllocationButton = (props: CreateAllocationButtonProps) => {
  //#region ------------------------------ Defaults
  const { className, onClick } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  //#endregion

  return (
    <Button
      className={classNames(className, classes.root)}
      type="link"
      size="large"
      iconProp={falPlus}
      onClick={onClick}
    >
      {t('accounting:incomingInvoices.drawerSteps.allocations.newAllocation')}
    </Button>
  );
};

export default CreateAllocationButton;
